/**
 * Returns true if the given value is an object of some kind and NOT NULL
 * @param value
 * @param allowNull True if null should also return TRUE
 */
export function isObject(value, allowNull) {
    return typeof value === 'object' && (allowNull === true || value !== null);
}
//# sourceMappingURL=isObject.js.map